<div class="row">
  <div class="col-12 col-lg-6">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Name -->
      <div class="form-group with-icon">
        <label for="name">{{'CONTACT.NAME' | translate}} <span class="req">*</span></label>
        <i class="icon custom-highlight"></i>
        <input id="name" type="text" formControlName="name" class="form-control"/>
        <div *ngIf="form.get('name')?.touched && form.get('name')?.invalid">
          <small class="text-danger">{{'CONTACT.FIELD_REQUIRED' | translate}}</small>
        </div>
      </div>

      <!-- Email -->
      <div class="form-group with-icon mt-3">
        <label for="email">{{'CONTACT.EMAIL' | translate}} <span class="req">*</span></label>
        <i class="icon custom-c-mail"></i>
        <input id="email" type="email" formControlName="email" class="form-control" autocomplete="off"/>
        <div *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
          <small *ngIf="form.get('email')?.errors?.['required']" class="text-danger">
            {{'CONTACT.FIELD_REQUIRED' | translate}}
          </small>
          <small *ngIf="form.get('email')?.errors?.['email']" class="text-danger">
            {{'CONTACT.EMAIL_VALIDATION' | translate}}
          </small>
        </div>
      </div>

      <!-- Message -->
      <div class="form-group mt-3">
        <label for="message">{{'CONTACT.QUESTION' | translate}} <span class="req">*</span></label>
        <textarea id="message" formControlName="message"></textarea>
        <div *ngIf="form.get('message')?.touched && form.get('message')?.invalid">
          <small *ngIf="form.get('message')?.errors?.['required']" class="text-danger">
            {{'CONTACT.FIELD_REQUIRED' | translate}}
          </small>
        </div>
      </div>

      <div class="button-wrap mt-4">
        <button type="submit" class="btn with-loader" [disabled]="!form.valid" [ngClass]="{'btn-primary': giPantMode, 'btn-primary-henterpant': henterPantMode}">
          {{'CONTACT.BUTTON' | translate}} <span class="loader" *ngIf="loading"></span>
        </button>
      </div>

      <div class="result" [ngClass]="{'gipant-m': giPantMode, 'henterpant-m': henterPantMode}">
        <p class="success" *ngIf="success" [innerHTML]="'CONTACT.SUCCESS' | translate"></p>
        <p class="error" *ngIf="error">{{'CONTACT.ERROR' | translate}}</p>
      </div>
    </form>
  </div>
  <div class="col-12 col-lg-6 text-center">
    <ng-container *ngIf="giPantMode">
      <h3>{{'CONTACT.GIPANT.TITLE' | translate}}</h3>
      <p class="description" [innerHTML]="'CONTACT.GIPANT.DESCRIPTION' | translate"></p>
    </ng-container>

    <ng-container *ngIf="henterPantMode">
      <h3>{{'CONTACT.HENTERPANT.TITLE' | translate}}</h3>
      <p class="description" [innerHTML]="'CONTACT.HENTERPANT.DESCRIPTION' | translate"></p>
    </ng-container>
  </div>
</div>
